import {EDIT_PROJECT_ERROR} from "../../../reducers/settingsReducer";

export const editProjectError = (error) =>{
    return {
        type: EDIT_PROJECT_ERROR,
        payload: {error}
    }
}